export const SIDE_BAR_BLOCKS = {
  inPageSpecialisms: {
    title: 'Page Specialisms',
    description: 'Lists the specialisms used in this page.',
    isEditable: false
  },
  specialismCloudBlogPosts: {
    title: 'Specialism Cloud (blog)',
    description: 'Lists the specialisms used in all blog posts.',
    isEditable: false
  },
  relatedBlogPosts: {
    title: 'Related Blog Posts',
    description: 'List related blog posts.',
    isEditable: false
  },
  relatedLandingPages: {
    title: 'Related Landing Pages',
    description: 'List related landing pages.',
    isEditable: false
  },
  newsletter: {
    title: 'Newsletter',
    description: 'Prompt for newsletter subscription.',
    isEditable: false
  },
  youtube: {
    title: 'Youtube Embed',
    description: 'Embed a Youtube video',
    isEditable: true
  },
  instagram: {
    title: 'Latest Instagram Post',
    description: 'Display the most recent Instagram post'
  }
}

export const IMAGE_MIME_TYPES = new Set(['image/png', 'image/jpeg', 'image/gif'])
